import { prop } from '@lib/style/theme';
import { FlexDirection, getJustifyAlign, getWrap, JustifyAlignValue, WrapType } from '@lib/style/utils';
import { cleanProps } from '@lib/utils';
import { css } from 'styled-components';

export interface FlexProps {
    fd: FlexDirection;
    layout: FlexDirection;
    flexDirection: FlexDirection;
    align: JustifyAlignValue;
    justify: JustifyAlignValue;
    wrap: WrapType;
    flex: string;
}

export const flex = (
    direction?: FlexProps['flexDirection'],
    align?: FlexProps['align'],
    justify?: FlexProps['justify'],
    flex?: FlexProps['flex'],
): any => css`
    & {
        flex-direction: ${prop(['fd', 'layout', 'flexDirection'], direction)};
        align-items: ${prop(['align'], align, getJustifyAlign)};
        align-content: ${prop(['align'], align, getJustifyAlign)};
        justify-content: ${prop(['justify'], justify, getJustifyAlign)};
        flex: ${prop(['flex'], flex)};
        flex-wrap: ${prop(['wrap'], null, getWrap)};
    }
`;

flex.clean = (props): any => cleanProps(props, ['fd', 'layout', 'flexDirection', 'align', 'justify', 'flex', 'wrap']);
